(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_fbaf152"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('b4t-fade-announcements')) {
customElements.define('b4t-fade-announcements',class extends HTMLElement {
connectedCallback(){this.messages=[...this.querySelectorAll('.b4t-announcement-message')];this.index=0;this.fitMobileText();this.resizeObserver=new ResizeObserver(()=>this.fitMobileText());this.resizeObserver.observe(this);if(this.messages.length>1)this.timer=setInterval(()=>{if(document.hidden)return;this.messages[this.index].classList.remove('is-active');this.messages[this.index].setAttribute('aria-hidden','true');this.index=(this.index+1)%this.messages.length;this.messages[this.index].classList.add('is-active');this.messages[this.index].setAttribute('aria-hidden','false');},4000);}
fitMobileText(){if(!window.matchMedia('(max-width:749px)').matches){this.style.removeProperty('--b4t-mobile-font-size');return;}this.style.setProperty('--b4t-mobile-font-size','13px');const style=getComputedStyle(this);const available=this.clientWidth-parseFloat(style.paddingLeft)-parseFloat(style.paddingRight);const widest=Math.max(...this.messages.map(message=>message.scrollWidth),1);const size=Math.min(13,Math.floor(13*available/widest*10)/10);this.style.setProperty('--b4t-mobile-font-size',size+'px');}
disconnectedCallback(){clearInterval(this.timer);this.resizeObserver?.disconnect();}
});
}
  } catch(e) { console.error(e); }
})();

})();
